import React, { useEffect, useState } from 'react';
import api from '../../api';
import Button from '../button';
import ButtonLink from '../button-link';
import Loader from '../loader';
import './article-newsletter-export-list.css';

const ArticleNewsletterExportList = () => {
  const [items, setItems] = useState([]);
  const [downloadUrls, setDownloadUrls] = useState({});
  const [loadingIdentifiers, setLoadingIdentifiers] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api.baseExport.listArticleNewsletters(
      data => {
        setItems(data);
        setIsLoading(false);
      },
      error => {
        console.error(error);
        setIsLoading(false);
      },
    );
  }, []);

  const handleExport = identifier => {
    setLoadingIdentifiers(current => ({
      ...current,
      [identifier]: true,
    }));

    api.baseExport.postArticleNewsletter(
      identifier,
      data => {
        setDownloadUrls(current => ({
          ...current,
          [identifier]: api.baseExport.getDownloadUrl(data.filename),
        }));
        setLoadingIdentifiers(current => ({
          ...current,
          [identifier]: false,
        }));
      },
      error => {
        console.error(error);
        setLoadingIdentifiers(current => ({
          ...current,
          [identifier]: false,
        }));
      },
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="article-newsletter-export-list">
      <p className="article-newsletter-export-list_title">Newsletters inline</p>

      {items.length === 0 && (
        <p className="article-newsletter-export-list_empty">Aucune inscription enregistrée.</p>
      )}

      {items.length > 0 && (
        <table className="article-newsletter-export-list_table">
          <thead>
            <tr>
              <th>Identifiant</th>
              <th>Inscrits</th>
              <th>Export</th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.identifier}>
                <td>{item.identifier}</td>
                <td>{item.count}</td>
                <td>
                  <div className="article-newsletter-export-list_actions">
                    <Button
                      disabled={loadingIdentifiers[item.identifier]}
                      label={loadingIdentifiers[item.identifier] ? 'Génération...' : 'Générer l\'export'}
                      onClick={() => handleExport(item.identifier)}
                      theme="success"
                      type="button"
                    />

                    {downloadUrls[item.identifier] && (
                      <ButtonLink
                        href={downloadUrls[item.identifier]}
                        icon="get_app"
                        label="Télécharger"
                        target="_blank"
                        theme="info"
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ArticleNewsletterExportList;
